import { documentsQueryOptions } from "@base/model/hooks/useDocumentsQuery";
import type { Document } from "@base/model/types/document";
import { useSuspenseQueries } from "@tanstack/react-query";
import { useProjectsQuery } from "./useProjectsQuery";

export interface RecentDailyLog {
  document: Document;
  projectName: string;
  projectId: number;
}

export function useRecentDailyLogsQuery(): RecentDailyLog[] {
  const { data: projectsData } = useProjectsQuery();
  const projects = projectsData.projects;

  const dailyLogResults = useSuspenseQueries({
    queries: projects.map((project) =>
      documentsQueryOptions({ projectId: project.id, type: "DAILY_LOG", page_size: 1 }),
    ),
  });

  return dailyLogResults.flatMap((result, i) => {
    const project = projects[i];
    const doc = result.data.results[0];
    if (!project || !doc) return [];
    return [{ document: doc, projectName: project.name, projectId: project.id }];
  });
}
